import moment from "moment";
import type { IDropdownOption } from "@fluentui/react";

export const getDateOfBirthMonthIndex = (month: any): number => {
    const monthIndex = Number(month);

    if (!Number.isInteger(monthIndex) || monthIndex < 0 || monthIndex > 11) {
        return 0;
    }

    return monthIndex;
};

export const getDateOfBirthDaysInMonth = (month: any): number => {
    const monthIndex = getDateOfBirthMonthIndex(month);
    let monthText = (monthIndex + 1).toString();
    if (monthText.length === 1) {
        monthText = "0" + monthText;
    }
    
    return moment(`2000-${monthText}`).daysInMonth();
};

export const getDateOfBirthDateOptions = (month: any): IDropdownOption[] =>
    Array.from({ length: getDateOfBirthDaysInMonth(month) }, (_, idx) => ({
        key: idx + 1,
        text: (idx + 1).toString(),
    }));

export const clampDateOfBirthDay = (day: any, month: any): number => {
    const dayValue = Number(day);
    const safeDay = Number.isInteger(dayValue) && dayValue > 0 ? dayValue : 1;

    return Math.min(safeDay, getDateOfBirthDaysInMonth(month));
};
